// extracted by mini-css-extract-plugin
module.exports = {"blogLink":"mediumwidget-module--blog-link--3Ibhb"};